module.exports = __webpack_public_path__ + "static/media/deleteActivity.53b2b9db.png";